import { DatePicker } from '@mui/x-date-pickers-pro'
import { Button, Popover, Stack } from '@vapor/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

type SelectDatePopoverProps = {
  disabled?: boolean
  open: HTMLButtonElement | null
  min?: Date
  max?: Date
  defaultDate?: Date
  confirmButtonTitle?: string
  closePopover: () => void
  onDateSelected: (date: Date) => void
}

export default function SelectDatePopover(props: SelectDatePopoverProps) {
  const { open, disabled, min, max, defaultDate, confirmButtonTitle, onDateSelected, closePopover } = props
  const { t } = useTranslation()
  const [selectedDate, setSelectedDate] = useState<Date | null>(defaultDate ?? null)

  return (
    <>
      <Popover
        open={open !== null}
        anchorEl={open}
        onClose={closePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Stack direction="row" justifyContent="center" alignItems="center" m={1} spacing={1}>
          <DatePicker //
            disabled={disabled}
            value={selectedDate}
            onChange={(date) => {
              if (typeof date !== 'string') {
                setSelectedDate(date)
              }
            }}
            minDate={min}
            maxDate={max}
            slotProps={{ textField: { variant: 'outlined', sx: { width: '150px' } } }}
          />
          <Button
            disabled={onDateSelected === null}
            variant="contained"
            size="small"
            onClick={() => {
              if (selectedDate) onDateSelected(selectedDate)
            }}
            sx={{
              whiteSpace: 'nowrap',
              textAlign: 'center',
            }}
          >
            {confirmButtonTitle ?? t('commons.confirm')}
          </Button>
        </Stack>
      </Popover>
    </>
  )
}
